<template>
	<div class="common">
		<div class="toplabelsty" :class="ismove?'moveparsty':''"></div>
		<div class="centconsty boxsizing" :style="{'min-height':ismove?(min_height-270)+'px':(min_height-260)+'px'}">
			<el-form class="elformSty filxwrap boxsizing" label-position="top">
				<div class="marbtnclsty">
					<el-form-item>
						<el-select class="allwidsty" placeholder="点此切换年级考测评" v-model="grade_id" @change="recordGetList">
							<el-option v-for="(item,i) in levelList" :key="i" :label="item.name" :value="item.id"></el-option>
						</el-select>
						<img src="../../assets/imgs/qiehuan@2x.png" />
					</el-form-item>
				</div>
			</el-form>
			<div class="con_tab_data">
				<div>
					<div v-if="recordList.length>0">
						<div class="item" v-for="(item,index) in recordList" :key="index">
							<div class="item_left">
								<div>{{item.name}}</div>
								<div class="num">{{item.createtime}}</div>
							</div>
							<div class="item_right" @click="downloadFun(item.id)">查看报告</div>
						</div>
					</div>
					<div class="zanwu" v-else>暂无数据</div>
				</div>
			</div>
		</div>
		<div class="botfootsty boxsizing" v-if="!ismove">
			<div class="ctwninparsty">
				版本号：{{cominfo.version}}，
				备案号：<a href="https://beian.miit.gov.cn/" cla target="_blank">{{cominfo.beian}}</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "common",
		data() {
			return {
				ismove: false, //是否显示导航
				isshow: false, //是否显示弹窗
				configurat:{}, //配置信息
				showhide: false, //是否显示顶部完整样式
				min_height: window.innerHeight, //窗口的高度
				cominfo: {}, //版权所属
				grade_id: '', //年级
				subject_id:'', //学科
				app_id:'', //平台id
				member_id:'', //用户id
				levelList: [],
				recordList: [], //测评记录列表
			};
		},
		computed: {

		},

		mounted() {
			this.initFun();
			this.sizeFun();
			this.gradeFun();
			window.addEventListener('resize', this.sizeFun);
		},
		methods: {
			// 改变页面大小方法
			sizeFun() {
				setTimeout(() => {
					this.ismove = this.$parent.ismove;
					this.min_height = window.innerHeight;
				}, 100)
			},
			// 页面加载方法
			initFun() {
				var that = this;
				if (this.$utile.locatFun('cominfo')) {
					this.cominfo = JSON.parse(localStorage.getItem('cominfo'));
				} else {
					this.$api.POST(this.$face.user_agreementSet, function(res) {
						localStorage.setItem("cominfo", JSON.stringify(res.data));
						that.cominfo = res.data;
					});
				}
				// 登录方法
				var app_id = this.getUrlParam('app_id'),
					subject_id = this.getUrlParam('subject_id'),
					grade_id = this.getUrlParam('grade_id');
				if(subject_id&&subject_id!=''&&subject_id!=null&&subject_id!='undefined') {
					this.subject_id = Number(subject_id);
				}
				if(grade_id&&grade_id!=''&&grade_id!=null&&grade_id!='undefined') {
					this.grade_id = Number(grade_id);
				}
				if(app_id!=null&&app_id!=''&&app_id!=undefined&&app_id!='undefined') {
					this.app_id = app_id;
					this.member_id = this.getUrlParam('member_id');
					that.recordGetList();
				}
			},
			// 获取路径中的参数
			getUrlParam(name) {
				let params_str = location.search.substring(1);
				let params_dic = {};
				params_str.split("&").forEach((item) => {
					let paramItem_list = item.split("=");
					if (paramItem_list.length === 2) {
						params_dic[paramItem_list[0]] = paramItem_list[1];
					}
				});
				return decodeURIComponent(params_dic[name]);
			},
			// 获取年级方法
			gradeFun(){
				var that = this;
				this.$api.POST(this.$face.index_grade, function(res) {
					that.levelList = res.data;
					// that.grade_id = res.data[0].id;
				});
			},
			//测评记录列表
			recordGetList() {
				var that = this;
				this.$api.POST(this.$face.index_record, {
					app_id: this.app_id,
					member_id: this.member_id,
					subject_id: this.subject_id,
					grade_id: this.grade_id,
				},function(res) {
					that.recordList = res.data.list;
				});
			},
			//下载报告
			downloadFun(id) {
				const routeData = this.$router.resolve({
					name: 'evaluationReport',
					query: {
						id: id
					}, //参数
				});
				window.open(routeData.href, '_blank');
			},
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.common {
		width: 100%;
		height: auto;
		min-height: 100%;
	}
	.toplabelsty {
		position: relative;
		width: 100%;
		height: 200px;
		background: url("../../assets/imgs/backimg.png") no-repeat;
		background-size: 100% 554px;
		background-position: center center;
	}

	/* 中间区域样式 */
	.centconsty {
		position: relative;
		max-width: 1200px;
		z-index: 2;
		height: auto;
		margin: 0px auto;
		padding-top: 10px;
	}

	/* 底部样式 */
	.botfootsty {
		width: 100%;
		height: 60px;
		padding-top: 20px;
		overflow: hidden;
		background-color: rgba(34, 34, 34, 1);
	}

	.ctwninparsty,.ctwninparsty a{
		width: 100%;
		height: 20px;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		line-height: 20px;
		text-align: center;
		color: rgba(117, 118, 119, 1);
	}
	.ctwninparsty a:hover{
		text-decoration: underline;
	}
	/* 移动端样式 */
	.moveparsty {
		width: 100%;
		height: 270px;
		background: url('../../assets/imgs/backimg.png') no-repeat;
		background-size: 100% 100%;
		background-position: left top;
	}
	.marbtnclsty img {
		width: 14px;
		height: 14px;
		margin-left: -22px;
	}

	.marbtnclsty>>>.el-form-item__label::before,
	.marbtnclsty>>>.el-form-item__label::before,
	.marbtnclsty>>>.el-select .el-input .el-select__caret {
		display: none !important;
	}


	.elformSty>>>.el-input__inner {
		/* width: 100% !important;
		height: 50px !important;
		border: none !important;
		line-height: 50px !important;
		border-radius: 8px !important;
		background: rgba(246, 250, 255, 1) !important; */
		border: 1px solid rgba(62, 136, 254, 1) !important;
		display: flex;
		align-items: center;
		justify-content: space-between;
		opacity: 1;
		/** 文本1 */
		width: 165px;
		height: 30px;
		border-radius: 5px;
		background: rgba(7, 49, 144, 0);
		box-sizing: border-box;
		padding: 0 8px;
		cursor: pointer;
		color: rgba(62, 136, 254, 1) !important;
	}

	.elformSty>>>.el-input__inner::placeholder {
		font-size: 14px;
		font-weight: 500;
		color: rgba(62, 136, 254, 1) !important;
	}

	.con_tabbox {
		margin: 10px 0;
		width: 100%;
		height: 70px;
		opacity: 1;
		border-radius: 5px;
		background: rgba(255, 255, 255, 1);
		padding: 10px 15px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.con_tabbox div {
		width: 580px;
		height: 50px;
		opacity: 1;
		border-radius: 5px;
		cursor: pointer;
		font-size: 18px;
		letter-spacing: 0px;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
	}

	.con_tab_active {
		background: rgba(78, 142, 255, 1) !important;
		color: rgba(255, 255, 255, 1) !important;
		font-weight: 700 !important;
	}

	.con_tab_data {
		width: 100%;
		opacity: 1;
		border-radius: 5px;
		background: rgba(255, 255, 255, 1);
		box-sizing: border-box;
		padding: 0 30px;
	}

	.con_tab_data .item {
		width: 100%;
		box-sizing: border-box;
		padding: 15px 30px 15px 48px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		display: flex;
		align-items: center;
		justify-content: space-between;
		/** 文本1 */
		font-size: 16px;
		font-weight: 500;
		letter-spacing: 0px;
		color: rgba(51, 51, 51, 1);
		cursor: pointer;
	}

	.con_tab_data .item .num {
		font-size: 12px;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		margin-top: 10px;
	}


	.con_tab_data .item .item_right {
		width: 80px;
		height: 30px;
		opacity: 1;
		border-radius: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid rgba(78, 142, 255, 1);
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(78, 142, 255, 1);

	}

	.con_tab_data .item .item_right img {
		width: 16px;
		height: 16px;
		margin-left: 8px;
	}

	.con_tab_data .item .item_right_img {
		width: 30px;
	}

	.con_tab_data .item:last-child {
		border-bottom: none;
	}

	@media screen and (max-width:1200px) {
		.index {
			padding: 16px;
		}
	}

	@media screen and (max-width:600px) {
		.con_tabbox div {
			height: 40px;
			font-size: 16px;
		}

		.con_tabbox {
			height: 60px;
			margin-top: 0;
		}

		.con_tab_data {
			background: none;
			padding: 0;
		}

		.con_tab_data .item {
			background-color: #fff;
			border: none;
			margin-bottom: 10px;
			border-radius: 8px;
			padding: 15px 20px;
		}

		.elformSty {
			top: 0px;
			left: 0px;
			right: 0px;
			height: 50px;
			margin-bottom: 20px;
			padding: 0px 31px;
			background-color: #ffffff;
		}

	}

	.zanwu {
		text-align: center;
		padding: 30px 0;
	}
</style>